import { datadogRum } from '@datadog/browser-rum';
import { datadogLogs } from '@datadog/browser-logs';
import { DATADOG_SAMPLE_RATE } from '../../constants.js';
class Datadog {
    constructor(config, options) {
        this.options = {};
        if (options) {
            this.options = options;
        }
        this.name = 'datadog';
        datadogRum.init({
            ...config,
            sessionSampleRate: DATADOG_SAMPLE_RATE,
            sessionReplaySampleRate: 20,
            trackUserInteractions: true,
            trackResources: true,
            trackLongTasks: true,
            defaultPrivacyLevel: 'mask-user-input',
            enableExperimentalFeatures: ['clickmap']
        });
        datadogLogs.init({
            ...config,
            forwardErrorsToLogs: true,
            sessionSampleRate: DATADOG_SAMPLE_RATE
        });
        window.onerror = function (message, source, lineno, colno, error) {
            datadogLogs.logger.error(error?.message || '', {
                error: { stack: error?.stack }
            });
        };
    }
    trackActivity(params) {
        const { user, title, ...restParams } = params;
        if (user) {
            if (this.options.withSocialConnection) {
                datadogRum.setUser({
                    ...user,
                    socialConnection: user.id.split('-')[0]
                });
                datadogRum.addRumGlobalContext('usr', {
                    ...user,
                    socialConnection: user.id.split('-')[0]
                });
            }
            else {
                datadogLogs.setUser({ ...user });
                datadogRum.setUser({
                    ...user
                });
                datadogRum.addRumGlobalContext('usr', { ...user });
                datadogRum.startSessionReplayRecording();
            }
        }
        datadogRum.addAction(title, { ...restParams });
    }
}
export default Datadog;
//# sourceMappingURL=datadog.js.map